module.exports = {
    init: function () {
        $(document).on('click', '.js-hide-show-password', function(event) {
            event.preventDefault();
            var $this = $(this),
                $input  = $this.closest('.form-row').find('input'),
                inputType = $input.attr('type');
            if (inputType === 'text') {
                $input.attr('type','password');
                $this.removeClass('hide-password').addClass('show-password').text(Resources.SHOW).attr('aria-label', 'Show password');
            } else {
                $input.attr('type','text');
                $this.removeClass('show-password').addClass('hide-password').text(Resources.HIDE).attr('aria-label', 'Hide password');
            }
            $input.focus();
        });

        $(document).on('keydown', '.js-hide-show-password', function(event) {
            // Check for Enter key (13)
            if (event.which === 13) {
                event.preventDefault();
                $(this).click();
            }
        });

    }
};
